import { createSlice } from "@reduxjs/toolkit";
import { getGroupParticipants } from "../actions/fluxoNSimilar";
import { GetGroupParticipantsResponse } from "../../types/gruposResponsabilidade";

type RequestStatus = "idle" | "loading" | "ready" | "error";

interface GroupParticipantsState {
  participantsByGroupId: Record<string, GetGroupParticipantsResponse>;
  statusByGroupId: Record<string, RequestStatus>;
  errorByGroupId: Record<string, unknown>;
}

const initialState: GroupParticipantsState = {
  participantsByGroupId: {},
  statusByGroupId: {},
  errorByGroupId: {},
};

const sessionGroupParticipantsSlice = createSlice({
  name: "sessionGroupParticipants",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGroupParticipants.pending, (state, action) => {
        const { groupId } = action.meta.arg;
        state.statusByGroupId[groupId] = "loading";
        delete state.errorByGroupId[groupId];
      })
      .addCase(getGroupParticipants.fulfilled, (state, action) => {
        const { groupId } = action.meta.arg;
        state.statusByGroupId[groupId] = "ready";
        state.participantsByGroupId[groupId] = action.payload;
        delete state.errorByGroupId[groupId];
      })
      .addCase(getGroupParticipants.rejected, (state, action) => {
        const { groupId } = action.meta.arg;
        state.statusByGroupId[groupId] = "error";
        state.errorByGroupId[groupId] = action.payload ?? action.error;
      });
  },
});

export default sessionGroupParticipantsSlice.reducer;